import { render, staticRenderFns } from "./deadline.vue?vue&type=template&id=1b06237b&scoped=true&"
import script from "./deadline.vue?vue&type=script&lang=js&"
export * from "./deadline.vue?vue&type=script&lang=js&"
import style0 from "./deadline.vue?vue&type=style&index=0&id=1b06237b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b06237b",
  null
  
)

export default component.exports